<template>
  <v-card>
    <v-card-title class="font-weight-bold caption">{{order.uuid}}</v-card-title>
    <v-card-subtitle>{{order.placed_at}}</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-chip class="ma-1">Kitchen | {{order.kitchen}}</v-chip>
        <v-chip class="ma-1">Platform | {{order.platform}}</v-chip>
      </v-row>
      <v-divider></v-divider>
      <template v-for="(item, i) in order.items">
        <v-row :key="'item' + i">
          <v-col cols="12" class="py-1">
            <v-icon
              small
              class="mr-2"
              :color="itemCompleted(item).color"
            >{{itemCompleted(item).icon}}</v-icon>
            <span class="font-weight-bold">{{item.quantity}} x {{item.label}}</span>
          </v-col>
        </v-row>
        <template v-for="(modifier, j) in item.modifiers">
          <v-row :key="'item' + i + 'modifier' + j">
            <v-col cols="12" class="py-1">
              <span class="pl-4">
                <v-icon
                  small
                  class="mr-2"
                  :color="itemCompleted(modifier).color"
                >{{itemCompleted(modifier).icon}}</v-icon>
                <span>{{modifier.quantity}} x {{modifier.label}}</span>
              </span>
            </v-col>
          </v-row>
          <template v-for="(submodifier, k) in modifier.submodifiers">
            <v-row :key="'item' + i + 'modifier' + j +'submodifier' + k">
              <v-col cols="12" class="py-1">
                <span class="pl-4">
                  <v-icon
                    small
                    class="mr-2"
                    :color="itemCompleted(submodifier).color"
                  >{{itemCompleted(submodifier).icon}}</v-icon>
                  <span>{{submodifier.quantity}} x {{submodifier.label}}</span>
                </span>
              </v-col>
            </v-row>
          </template>
        </template>
      </template>
      <v-divider></v-divider>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="normalize" color="green" dark>Normalize</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: { order: { type: Object } },
  methods: {
    itemCompleted(item) {
      if (item.uuid === "UNKNOWN") {
        return {
          icon: "mdi-clipboard-alert",
          color: "red",
        };
      }
      return {
        icon: "mdi-clipboard-check",
        color: "green",
      };
    },
    normalize() {
      this.$emit("normalize", this.order.uuid);
    },
  },
};
</script>
